import { logoutUser } from "../services/auth"

export const expiredToken = () => {
  logoutUser()
  window.location.replace("/")
}
